import { Button, useTheme } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { handleHeight, handleFontSize } from "./utils";

export const ButtonTertiary = ({
  onClick,
  disabled,
  startIcon,
  endIcon,
  children,
  sx,
  id,
  size = "sm",
}: IButtons) => {
  const theme = useTheme();
  return (
    <Button
      id={id}
      // variant="text"
      onClick={onClick}
      disabled={disabled}
      disableRipple
      sx={{
        color: theme.palette.systemSecondary01,
        height: handleHeight(size),
        opacity: disabled ? 0.3 : 1,
        lineHeight: "1.5rem",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: handleFontSize(size),
        fontStyle: "normal",
        padding: "0.78rem 1rem",
        "&:hover": {
          backgroundColor: "transparent",
          color: theme.palette.text.primary,
        },
        //TODO da finire i vari stati (active, focus)
        ...sx,
      }}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {children}
    </Button>
  );
};
